// extracted by mini-css-extract-plugin
export default {"container":"Layout-module__container--2186","header":"Layout-module__header--b19a","body":"Layout-module__body--d17a","contentArea":"Layout-module__contentArea--cae1"};